import { Icon } from '@joehua/buzz-components';
import * as React from 'react';
import { themr } from 'react-css-themr';
const DumpHotline = ({ data, theme = {} }) => {
    if (!data) {
        return null;
    }
    const { text, icon, number } = data;
    return (React.createElement("a", { className: theme.root, href: `tel:${number}` },
        icon && React.createElement(Icon, { icon: icon }),
        React.createElement("span", { className: theme.text }, text)));
};
export const defaultHotlineTheme = {
    root: 'dib ph3 pv2 bg-red near-white link',
};
const Hotline = themr('Hotline', {}, {
    composeTheme: 'softly',
})(DumpHotline);
export default Hotline;
//# sourceMappingURL=index.js.map